<ng-container *ngIf="!accountLoading && (account$ | async) as account; else contentLoading">

  <div class="flex align-items-center mb-3">
    <span class="p-input-icon-left flex-grow-1 mr-3">
      <i class="pi pi-search"></i>
      <input
        pInputText
        type="text"
        class="w-full"
        (input)="blogsTable.filterGlobal($any($event).target.value, 'contains')"
        placeholder="Search articles"
      />
    </span>
    <button
      pButton
      pRipple
      type="button"
      label="New article"
      icon="pi pi-plus"
      class="p-button-rounded flex-shrink-0"
      (click)="onAddBlog()"
    ></button>
  </div>

  <p-table
    #blogsTable
    [value]="blogsAsList(account.data?.content)"
    [globalFilterFields]="['title', 'slug', 'category']"
    styleClass="mt-3 p-datatable-striped"
    dataKey="_meta.id"
    responsiveLayout="scroll"
    [paginator]="true"
    [rows]="20"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Title</th>
        <th>Category</th>
        <th>Published</th>
        <th>Date</th>
        <th style="width: 12rem"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-blog>
      <tr>
        <td><strong>{{ blog.title || '(untitled)' }}</strong></td>
        <td>{{ blog.category || '—' }}</td>
        <td>
          <i *ngIf="blog.published === true" class="pi pi-check app-text-ok" title="Published"></i>
          <i *ngIf="blog.published !== true" class="pi pi-pencil text-500" title="Draft"></i>
        </td>
        <td>{{ blog.publishedAt ? (blog.publishedAt | date: 'd MMM y') : '—' }}</td>
        <td>
          <button
            pButton pRipple type="button" icon="pi pi-pencil"
            (click)="onEditBlog(blog)"
            class="p-button-rounded p-button-text" title="Edit"
          ></button>
          <!-- Scoped publish: ships THIS article only, leaving the rest of the
               site exactly as deployed. Needs a slug (the publish scope is
               keyed on it). -->
          <button
            pButton pRipple type="button"
            [icon]="publishingSlug === blog.slug ? 'pi pi-spin pi-spinner' : 'pi pi-cloud-upload'"
            (click)="onPublishBlog(blog)"
            [disabled]="!blog.slug || !!publishingSlug"
            class="p-button-rounded p-button-text"
            [title]="!blog.slug ? 'Give the article a slug first' : 'Publish just this article to the staging preview'"
          ></button>
          <button
            pButton pRipple type="button" icon="pi pi-trash"
            (click)="onDeleteBlog(blog)"
            class="p-button-rounded p-button-danger p-button-text" title="Remove"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="p-text-center muted p-py-5">
          No articles yet. Use "New article" to write the first one.
        </td>
      </tr>
    </ng-template>
  </p-table>

</ng-container>

<!-- Shown while the account loads. Without it the modal opens onto an empty
     body for a second or two, which reads as broken rather than busy. -->
<ng-template #contentLoading>
  <div class="flex flex-column align-items-center justify-content-center p-6 text-500">
    <i class="pi pi-spin pi-spinner text-3xl mb-3" aria-hidden="true"></i>
    <span>Loading…</span>
  </div>
</ng-template>
